import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

export const exportOrders = (requestUrl, requestBody) => {
  const post = axios.post(requestUrl, requestBody).then((response) => {
    return get(response, 'data');
  });

  const post$ = from(post);
  return post$;
};

export const customExportOrders = ({ filters, extractId, ordersQuickSearchParams }) => {
  const requestBody = {
    filters,
    extractId,
    ordersQuickSearchParams,
  };
  const post = axios.post('/seller/customextracts/exportOrders', requestBody).then((response) => {
    return get(response, 'data');
  });
  const post$ = from(post);
  return post$;
};
